import { render } from "./PurchaseDefectiveItemAggregate.vue?vue&type=template&id=3dfe35e3"
import script from "./PurchaseDefectiveItemAggregate.vue?vue&type=script&lang=js"
export * from "./PurchaseDefectiveItemAggregate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__